/** 订阅主弹窗需高于导演台全屏工作区（9999）及其浮层（10000）。 */
export const VIP_MODAL_Z_INDEX = 11000;

/** 支付、明细等订阅子弹窗需继续覆盖订阅主弹窗。 */
export const VIP_MODAL_CHILD_Z_INDEX = VIP_MODAL_Z_INDEX + 10;
